function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext } from "react";
import { useUIDSeed } from "react-uid";
import { LinkContext } from "../../../context";
import { Body, Divider } from "../../atoms";
import { OfficeInfoBlock, Section } from "../../molecules";
import { twMerge } from "../../../utils";
export var Footer = function(param) {
    var info = param.info, badges = param.badges, legalInfo = param.legalInfo, officeInfo = param.officeInfo, socialMenuItems = param.socialMenuItems, hideDivider = param.hideDivider, lines = param.lines, className = param.className;
    var seed = useUIDSeed();
    var LinkComponent = useContext(LinkContext).LinkComponent;
    return /*#__PURE__*/ React.createElement(Section, {
        lines: lines !== null && lines !== void 0 ? lines : false,
        contentClassName: "py-0 md:py-0",
        className: twMerge(className, hideDivider && "mt-7")
    }, !hideDivider && /*#__PURE__*/ React.createElement(Divider, {
        variant: "full-width",
        background: "transparent"
    }), badges && /*#__PURE__*/ React.createElement("div", {
        className: "container pt-2 pb-5 flex flex-col md:flex-row items-start md:items-center justify-start gap-8"
    }, badges), /*#__PURE__*/ React.createElement("div", {
        className: "container py-7 grid gap-7 grid-areas-footer/sm grid-cols-2 md:grid-cols-6 md:grid-areas-footer/md"
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "145",
        height: "38",
        viewBox: "0 0 145 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "grid-in-logo fill-current max-w-[7rem] h-auto md:max-w-[9.5rem]"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M96.4543 16.2666C101.183 17.7302 106.861 19.4875 106.828 26.364L106.823 26.354C106.823 32.9946 101.114 35.9902 94.8107 35.9902H94.7866C90.1947 35.9902 85.3054 34.4031 82.1802 31.4771L84.5959 26.478C87.3091 28.9775 91.6758 30.5049 95.0935 30.5049C97.9839 30.5049 100.222 29.4685 100.222 27.0286C100.222 24.1719 97.1766 23.2292 93.7063 22.1553C89.0972 20.729 83.7388 19.0708 83.7716 12.3882C83.7716 5.80225 89.3126 2.99512 95.3282 2.99512C99.2781 2.99512 103.467 4.21509 106.296 6.28809L103.817 11.4758C101.047 9.70532 97.447 8.60913 94.7963 8.60913C92.1455 8.60913 90.1993 9.52661 90.1993 11.8428C90.1993 14.3306 93.0863 15.2241 96.4543 16.2666Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M48.7656 28.8633L40.0369 3.30737H32.9619L45.1083 35.7568H52.1257L64.1522 3.30737H57.3744L48.7656 28.8633Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M75.9298 3.30737H69.2095V35.7617H75.9298V3.30737Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M144 19.5298C144 9.71021 137.337 3.05957 127.669 3.05957C118.001 3.05957 111.276 9.71021 111.276 19.5298C111.276 29.3496 117.934 35.9951 127.66 36H127.674C137.337 36 144 29.29 144 19.5298ZM127.669 30.1431C122.008 30.1431 118.058 25.8728 118.058 19.5894C118.058 13.3057 122.008 9.09521 127.669 9.09521C133.33 9.09521 137.222 13.3652 137.222 19.5894C137.222 25.8135 133.273 30.1431 127.669 30.1431Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.79517 9.32861L7.78735 13.1472H7.79224V35.8069H1V3.37231H7.78735C9.18652 3.37231 10.5582 3.36938 12.1029 3.36621C14.0931 3.36206 16.3704 3.35742 19.3633 3.35742C26.6876 3.35742 31.0543 7.88037 31.0591 15.6221V35.8069H24.2668V18.2952C24.2668 12.6265 22.594 10.385 16.7078 10.385H10.6346L6.79517 9.32861Z"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-content"
    }, info), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-2 grid-flow-row auto-rows-auto gap-7 grid-in-info md:grid-cols-4"
    }, officeInfo.map(function(entry) {
        return /*#__PURE__*/ React.createElement(OfficeInfoBlock, _extends({
            key: seed(entry)
        }, entry));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-social grid grid-cols-[auto_1fr] grid-flow-row auto-rows-max gap-x-5 gap-y-3 md:gap-5 md:grid-cols-1"
    }, socialMenuItems.map(function(_param) /*#__PURE__*/ {
        var icon = _param.icon, entry = _objectWithoutProperties(_param, [
            "icon"
        ]);
        return React.createElement(LinkComponent, _extends({
            key: seed(entry)
        }, entry, {
            className: "flex items-center group"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "mr-3"
        }, icon), /*#__PURE__*/ React.createElement(Body, {
            variant: "small",
            className: "text-fg-inbetween group-hover:text-brand-primary-base"
        }, entry.label));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-legal justify-between items-center md:flex"
    }, /*#__PURE__*/ React.createElement(Body, {
        as: "div",
        variant: "small",
        className: "text-fg-inbetween"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex -mx-2"
    }, legalInfo.menuItems.map(function(item) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _extends({
            key: seed(item)
        }, item, {
            className: "mx-2 after:ml-2 after:pointer-events-none after:content-['|'] last-of-type:after:hidden hover:text-brand-primary-base"
        }), item.label);
    }))), /*#__PURE__*/ React.createElement(Body, {
        variant: "small",
        className: "text-fg-inbetween"
    }, /*#__PURE__*/ React.createElement("p", null, legalInfo.disclaimer)))));
};

//# sourceMappingURL=Footer.js.map